import { class_of_use_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateClassOfUseEnum = (enumValue: class_of_use_enum) => {
  switch (enumValue) {
    case class_of_use_enum.COMMERCIAL:
      return <Trans i18nKey="Enum_ClassOfUseEnum-COMMERCIAL" />;
    case class_of_use_enum.RESIDENTIAL:
      return <Trans i18nKey="Enum_ClassOfUseEnum-RESIDENTIAL" />;
  }
};

export const translateClassOfUseEnum_dynamic = (enumValue: class_of_use_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case class_of_use_enum.COMMERCIAL:
      return t('Enum_ClassOfUseEnum-COMMERCIAL');
    case class_of_use_enum.RESIDENTIAL:
      return t('Enum_ClassOfUseEnum-RESIDENTIAL');
  }
};
